/**
 * 表格单元格双击复制（行为与工单管理 material/index.vue、指派管理 assign/index.vue、
 * 任务管理 task/index.vue 里各自那份 copyText 逐字一致）。
 *
 * 注：那三个页面各抄了一份同样的实现，本 mixin 是收敛的起点——新页面一律引本文件，
 * 老页面可后续替换（替换属独立改动，避免夹带回归）。
 * 不用 src/utils/clipboard.js：那是脚手架自带死代码（0 使用者，提示还是英文 Copy successfully）。
 */
export default {
    methods: {
        copyText(text) {
            // '-' 是工单管理的空占位，'—' 是排单管理的（em dash），两种都不复制
            if (!text || text === '-' || text === '—') return;
            const textarea = document.createElement('textarea');
            textarea.value = text;
            document.body.appendChild(textarea);
            textarea.select();
            document.execCommand('copy');
            document.body.removeChild(textarea);
            this.$message.success('复制成功');
        },
    },
};
